import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React, { useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import { logout } from '@modules/Auth';
import useSessionTimeout from '@/hooks/useSessionTimeout';
import { INACTIVITY_TIMEOUT, PROMPT_BEFORE_IDLE_TIMEOUT } from '@/consts';

// TODO move this to a shared location e.g. fe-common (copied from MMM)
const SessionTimeout: React.FC = () => {
  const { instance } = useMsal();
  const handleLogout = useCallback(() => logout(instance), [instance]);
  const { isOpenLogOut, onResetSession } = useSessionTimeout(handleLogout);

  const handleClose = useCallback(
    (_, reason) => {
      if (reason && reason === 'backdropClick') return;
      handleLogout();
    },
    [handleLogout],
  );

  const inActivityTime = INACTIVITY_TIMEOUT / 60000 - PROMPT_BEFORE_IDLE_TIMEOUT / 60000;

  return (
    <Dialog open={isOpenLogOut} onClose={handleClose} maxWidth='md'>
      <DialogTitle id='alert-dialog-title'>Session has expired</DialogTitle>
      <DialogContent>
        <DialogContentText>You have been inactive for {inActivityTime} minutes. Do you want to stay logged in?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color='primary' size='medium' onClick={onResetSession}>
          Continue
        </Button>
        <Button size='medium' onClick={handleLogout}>
          Sign Out
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionTimeout;
